"use client"
import React from 'react';
import Link from "next/link";

const BrandResult = ({data}: { data: any }) => {
    const brands = data?.brands

    return (
        <>
            {brands?.length > 0 ? (
                <div>
                    <h4 className={"text-base"}>برندها</h4>
                    <div className={"grid grid-cols-3 gap-2 mt-2"}>
                        {brands?.map((item: any, index: number) => (
                            <Link
                                target={"_blank"}
                                href={`/brand/${item?.slug}`}
                                key={index}
                                className={"h-[42px] w-[118px] border border-[#EBEBEB] rounded-full flex flex-col items-center justify-center hover:text-orange-primary hover:border-orange-primary transition-all"}>{item?.title}</Link>
                        ))}
                    </div>
                </div>
            ) : (
                <div className={"flex flex-col min-h-24 items-center justify-center"}>برندی یافت
                    نشد</div>
            )}
        </>
    );
};

export default BrandResult;